import { useState, type FormEvent } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { ApiError } from '../api/client'
import { BrandMark } from '../app/BrandMark'
import { useRedeemResetCode } from './useOnboarding'

// Öffentliche Chef-Aktivierung: der neue Werkstatt-Inhaber setzt per Aktivierungscode sein Passwort SELBST (der
// Betreiber vergibt keins). Der Code kommt aus dem Magic-Link (?code=) oder wird manuell eingegeben; eingelöst wird
// über denselben Reset-Redeem wie beim Mitarbeiter-Reset (POST onboarding/reset). Kein Login nötig.
export function ChefActivationPage() {
  const [params] = useSearchParams()
  const redeem = useRedeemResetCode()
  const [code, setCode] = useState(params.get('code') ?? '')
  const [password, setPassword] = useState('')

  function onSubmit(e: FormEvent) {
    e.preventDefault()
    redeem.mutate({ code: code.trim(), password })
  }

  const errorMessage = redeem.error instanceof ApiError ? redeem.error.message : redeem.isError ? 'Aktivierung fehlgeschlagen' : null

  if (redeem.isSuccess) {
    return (
      <div className="centered">
        <div className="card login">
          <h1>Konto aktiviert</h1>
          <p className="hint">Dein Passwort ist gesetzt. Du kannst dich jetzt mit deinem Benutzernamen und dem neuen Passwort anmelden.</p>
          <Link to="/login" className="btn">
            Zur Anmeldung
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="centered">
      <form className="card login" onSubmit={onSubmit}>
        <div className="wf-loginbrand" aria-hidden="true">
          <BrandMark size={44} />
        </div>
        <h1>Willkommen bei Cevio</h1>
        <p className="hint">Setz dein Passwort, um dein Chef-Konto zu aktivieren.</p>
        <label className="field">
          <span>Aktivierungscode</span>
          <input
            name="code"
            autoCapitalize="characters"
            autoCorrect="off"
            spellCheck={false}
            placeholder="WF-RST-XXXX-XXXX-XXXX"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
          />
        </label>
        <label className="field">
          <span>Passwort (min. 8 Zeichen)</span>
          <input name="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        {errorMessage && (
          <p className="error" role="alert">
            {errorMessage}
          </p>
        )}
        <button type="submit" className="btn" disabled={redeem.isPending}>
          {redeem.isPending ? 'Wird aktiviert…' : 'Konto aktivieren'}
        </button>
        <nav className="wf-legalfoot" aria-label="Navigation">
          <Link to="/login">Zur Anmeldung</Link>
        </nav>
      </form>
    </div>
  )
}
